import classnames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import { STYLE_FILL } from '@eb/eds-button';
import { Button } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import Image from './Image';

import './heroBanner.scss';

import { ChevronDownChunky } from '@eb/eds-iconography';

const HeroBannerContent = ({ heading, smallScreen, CTA, onClick }) => {
    const headingContainerClasses = classnames({
        'eds-l-pad-top-8': smallScreen,
        'eds-g-cell eds-g-cell-1-1 eds-text--center': !smallScreen,
    });
    const headingClasses = classnames({
        'eds-text-hl': smallScreen,
        'eds-text-hxl eds-text-color--white eds-l-pad-bot-4': !smallScreen,
    });

    const buttonContainerClasses = classnames({
        'eds-align--center': !smallScreen,
    });

    return (
        <section className="marketing-hero-banner__content eds-g-cell eds-g-cell-1-1 eds-g-cell-sw-8-12">
            <h1 className={headingContainerClasses}>
                <div className={headingClasses}>{heading}</div>
            </h1>
            <div className="marketing-hero-banner__CTA  eds-g-cell eds-g-cell-1-1 eds-g-cell--has-overflow eds-l-mar-bot-12">
                <div className={buttonContainerClasses}>
                    <Button style={STYLE_FILL} onClick={onClick}>
                        {CTA}
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default class HeroBanner extends PureComponent {
    static propTypes = {
        /*
        Main title
        */
        heading: translationPropType,
        /*
        Secondary heading
        */
        secondaryHeading: translationPropType,
        /*
        Image to show with banner content
        */
        imagePath: PropTypes.string,
        /*
        CTA for button
        */
        CTA: translationPropType,
        /*
        Callback to trigger on click
        */
        onClick: PropTypes.func,
        /*
        Data automation string for testing
        */
        dataAutomation: PropTypes.string,
    };

    render() {
        const {
            heading,
            imagePath,
            CTA,
            onClick,
            dataAutomation,
            metadataHeading,
            metadataSecondaryHeading,
        } = this.props;

        if (!heading) {
            return null;
        }

        const bannerImageMetadata = (
            <figcaption className="marketing-hero-banner__image--metadata eds-g-cell eds-g-cell-1-1">
                <p className="eds-text-bm eds-text-weight--heavy eds-text-color--white">
                    {metadataHeading}
                </p>
                <p className="eds-text-bm eds-text-weight--regular eds-text-color--white">
                    {metadataSecondaryHeading}
                </p>
            </figcaption>
        );
        const bannerImageArrow = (
            <div className="marketing-hero-banner__image--arrow eds-show-up-sw">
                <Icon
                    type={<ChevronDownChunky />}
                    color="white"
                    size="medium"
                />
            </div>
        );

        return (
            <figure
                className="marketing-hero-banner"
                data-automation={dataAutomation}
            >
                <div className="eds-show-down-sm">
                    <HeroBannerContent
                        heading={heading}
                        CTA={CTA}
                        onClick={onClick}
                        smallScreen={true}
                    />
                    <Image imagePath={imagePath} />
                    {bannerImageMetadata}
                    {bannerImageArrow}
                </div>
                <div className="eds-show-up-sw">
                    <Image
                        __backgroundContainerClassName="marketing-hero-banner__image"
                        bgPosition="left"
                        bgSize="cover"
                        imagePath={imagePath}
                    >
                        <HeroBannerContent
                            heading={heading}
                            CTA={CTA}
                            onClick={onClick}
                            dataAutomation={dataAutomation}
                        />
                        {bannerImageMetadata}
                        {bannerImageArrow}
                    </Image>
                </div>
            </figure>
        );
    }
}
